if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.productSubtitle = this.querySelector('.product-subtitle');
        this.bundleInitialized = false;
        this.bundleIsUpdating = false;
        this.bundleRaf = null;
        this.bundleMutationLock = false;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (this.input && this.quantityForm) {
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        }
        this.initBundlePricing();
        this.initVariantSubtitle();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          if (this.quantityForm) {
          this.updateQuantityRules(event.data.sectionId, event.data.html);
            if (this.input) this.setQuantityBoundries();
          }
          if (event.data.variant?.title && this.productSubtitle) {
            this.productSubtitle.textContent = event.data.variant.title;
          }
          this.reapplyBundleAfterVariantChange(event.data.variant);
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      initVariantSubtitle() {
        if (!this.productSubtitle) return;

        const radios = this.querySelectorAll('variant-selects input[type="radio"]');
        const selects = this.querySelectorAll('variant-selects select');

        if (radios.length) {
          radios.forEach((radio) => {
            radio.addEventListener('change', (event) => {
              this.productSubtitle.textContent = event.currentTarget.value;
            });
          });
        }

        if (selects.length) {
          selects.forEach((select) => {
            select.addEventListener('change', (event) => {
              const option = event.currentTarget.selectedOptions?.[0];
              this.productSubtitle.textContent = option ? option.textContent : event.currentTarget.value;
            });
          });
        }
      }

      initBundlePricing() {
        if (this.bundleInitialized) return;

        this.bundleInitialized = true;
        this.refreshBundleReferences();

        if (this.bundleFieldset) {
          this.bundleFieldset.addEventListener('change', (event) => {
            const checkbox = event.target.closest('input[type="checkbox"].quantity-checkbox');
            if (!checkbox) return;
            if (this.bundleIsUpdating) return;

            if (checkbox.checked) {
              this.bundleIsUpdating = true;
              this.bundleFieldset.querySelectorAll('input[type="checkbox"].quantity-checkbox').forEach((cb) => {
                if (cb !== checkbox) cb.checked = false;
              });
              this.bundleIsUpdating = false;
              if (this.bundleHiddenInput) {
                this.bundleHiddenInput.value = checkbox.getAttribute('data-quantity');
              }
            } else if (this.bundleHiddenInput) {
              this.bundleHiddenInput.value = '1';
            }
            this.applyBundleSelection();
          });
        }

        this.applyBundleSelection();
      }

      refreshBundleReferences() {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        this.bundleFieldset = this.querySelector(`.quantity-bundle#Quantity-Form-${sectionId}`);
        this.bundleHiddenInput = this.querySelector(`#Quantity-Hidden-${sectionId}`);
        this.priceStatus = this.querySelector(`#price-${sectionId}`);
        this.bundlePriceEl = this.querySelector('[data-bundle-price]');
        this.bundleCompareEl = this.bundlePriceEl?.querySelector('.bundle-price__compare') || null;
        this.bundleSaleEl = this.bundlePriceEl?.querySelector('.bundle-price__sale') || null;
      }


      formatMoney(cents) {
        if (!this.priceStatus) return null;
        const currency = this.priceStatus.dataset.currencyIso;
        if (!currency) return null;
        const locale = document.documentElement.lang || 'en-US';
        const value = Number(cents || 0) / 100;
        const formatted = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'symbol',
          currencySign: 'standard',
        }).format(value);
        return `${formatted} ${currency}`;
      }

      updateBundlePrice(quantity, percent) {
        if (!this.priceStatus) return;
        const basePrice = parseInt(this.priceStatus.dataset.basePrice, 10);
        if (!Number.isFinite(basePrice)) return;

        const total = basePrice * quantity;
        const discount = Math.max(0, Math.min(100, Number(percent || 0)));
        const discountedTotal = Math.round(total * ((100 - discount) / 100));

        if (!this.bundleCompareEl || !this.bundleSaleEl) return;

        if (quantity > 1 && discount > 0) {
          const compareText = this.formatMoney(total);
          const saleText = this.formatMoney(discountedTotal);
          if (!compareText || !saleText) return;
          this.bundleCompareEl.textContent = compareText;
          this.bundleSaleEl.textContent = saleText;
          this.priceStatus.classList.add('bundle-price-active');
        } else {
          this.priceStatus.classList.remove('bundle-price-active');
        }

      }

      applyBundleSelection() {
        this.refreshBundleReferences();
        if (!this.bundleFieldset || !this.bundleHiddenInput) return;

        if (this.bundleRaf) cancelAnimationFrame(this.bundleRaf);
        this.bundleRaf = requestAnimationFrame(() => {
          this.bundleMutationLock = true;
          const checked = this.bundleFieldset.querySelector('input[type="checkbox"].quantity-checkbox:checked');
          if (checked) {
            const quantity = parseInt(checked.getAttribute('data-quantity'), 10) || 1;
            const percent = parseFloat(checked.getAttribute('data-percent')) || 0;
            this.updateBundlePrice(quantity, percent);
          } else {
            if (this.priceStatus) this.priceStatus.classList.remove('bundle-price-active');
          }
          requestAnimationFrame(() => {
            this.bundleMutationLock = false;
          });
        });
      }

      reapplyBundleAfterVariantChange(variant, attempt = 0) {
        this.refreshBundleReferences();
        if (!this.priceStatus) return;
        if (variant) {
          this.priceStatus.dataset.basePrice = variant.price;
          this.priceStatus.dataset.compareAtPrice = variant.compare_at_price || 0;
          this.priceStatus.dataset.variantOnSale = variant.compare_at_price > variant.price ? 'true' : 'false';
        }

        if (!this.bundleFieldset || !this.bundleHiddenInput) return;
        const checked = this.bundleFieldset.querySelector('input[type="checkbox"].quantity-checkbox:checked');
        if (!checked && this.bundleHiddenInput.value && this.bundleHiddenInput.value !== '1') {
          const match = this.bundleFieldset.querySelector(
            `input[type="checkbox"].quantity-checkbox[data-quantity="${this.bundleHiddenInput.value}"]`
          );
          if (match) match.checked = true;
        }
        if (!this.priceStatus.dataset.currencyIso && attempt < 5) {
          setTimeout(() => {
            this.reapplyBundleAfterVariantChange(undefined, attempt + 1);
          }, 50);
          return;
        }
        this.applyBundleSelection();
      }
    }
  );
}
